import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './RegistrationError.scss';

const RegistrationError = ({ onContinue, onRetry }) => {
  const intl = useIntl();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
  };

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <div className={styles['registration-error']}>
      <div className={styles['registration-error__card']}>
        <Header />

        <div className={styles['registration-error__body']}>
          <div className={styles['registration-error__icon']}>
            <IconWarning
              className={styles['registration-error__icon-symbol']}
              size="xl"
              isFilled={true}
              color="critical"
            />
          </div>
          <p className={styles['registration-error__message']}>
            {intl.formatMessage({ id: 'passkeyRegistration.error.message' })}
          </p>

          <div className={styles['registration-error__actions']}>
            <Button
              className={styles['registration-error__continue-btn']}
              variant="primary"
              onClick={handleRetry}
            >
              {intl.formatMessage({ id: 'passkeyRegistration.error.retryWithPasskey' })}
            </Button>

            <Button
              className={styles['registration-error__continue-btn']}
              variant="secondary"
              onClick={handleContinue}
            >
              {intl.formatMessage({ id: 'passkeyRegistration.error.continueWithoutPasskey' })}
            </Button>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

RegistrationError.propTypes = {
  onContinue: PropTypes.func,
  onRetry: PropTypes.func,
};

RegistrationError.defaultProps = {
  onContinue: undefined,
  onRetry: undefined,
};

export default RegistrationError;
